export { default as Img200 } from './processed/200/pierata.jpg';
export { default as Img400 } from './processed/400/pierata.jpg';
export { default as Img600 } from './processed/600/pierata.jpg';
export { default as Imgthumb } from './processed/thumb/pierata.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/pierata.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/pierata.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      15,
      116,
      231
    ],
    "_population": 2142,
    "_hsl": [
      0.5887345679012346,
      0.8780487804878049,
      0.4823529411764706
    ]
  },
  "LightVibrant": {
    "_rgb": [
      240,
      194,
      118
    ],
    "_population": 211,
    "_hsl": [
      0.10382513661202185,
      0.8026315789473684,
      0.7019607843137254
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      110,
      71,
      48
    ],
    "_population": 2492,
    "_hsl": [
      0.06182795698924731,
      0.3924050632911393,
      0.30980392156862746
    ]
  },
  "Muted": {
    "_rgb": [
      154,
      102,
      133
    ],
    "_population": 50,
    "_hsl": [
      0.9006410256410255,
      0.20472440944881887,
      0.5019607843137255
    ]
  },
  "LightMuted": {
    "_rgb": [
      171,
      189,
      204
    ],
    "_population": 293,
    "_hsl": [
      0.5757575757575757,
      0.24444444444444463,
      0.7352941176470589
    ]
  },
  "DarkMuted": {
    "_rgb": [
      67,
      48,
      31
    ],
    "_population": 1381,
    "_hsl": [
      0.0787037037037037,
      0.36734693877551017,
      0.19215686274509805
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/pierata.js